import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Orders from "layouts/orders";
import SignIn from "layouts/authentication/sign-in";
import AddUser from "layouts/UserForm";
import Products from "layouts/Products";
import Mosques from "layouts/mosques";
import Categories from "layouts/categories";
import Profile from "layouts/profile";
import Icon from "@mui/material/Icon";
import Cookies from "js-cookie";
const authToken = Cookies.get("authToken");

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Users",
    key: "tables",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/tables",
    component: <Tables />,
  },
  {
    type: "collapse",
    name: "Products",
    key: "products",
    icon: <Icon fontSize="small">shopping_cart</Icon>,
    route: "/products",
    component: <Products />,
  },
  {
    type: "collapse",
    name: "Categories",
    key: "categories",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/categories",
    component: <Categories />,
  },
  {
    type: "collapse",
    name: "Mosques",
    key: "mosques",
    icon: <Icon fontSize="small">mosque</Icon>,
    route: "/mosques",
    component: <Mosques />,
  },
  {
    type: "collapse",
    name: "Orders",
    key: "orders",
    icon: <Icon fontSize="small">attach_money</Icon>,
    route: "/orders",
    component: <Orders />,
  },
  {
    type: "collapse",
    name: "Add User",
    key: "addUser",
    icon: <Icon fontSize="small">person_add</Icon>,
    route: "/addUser",
    component: <AddUser />,
  },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  {
    type: "collapse",
    name: authToken ? "Sign Out" : "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
];

export default routes;
